/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppLoggerService {

  constructor() { }

  public error(message: string, ...optionalParams: any[]): void {
    console.error(message, optionalParams);
  }

  public info(message: string, ...optionalParams: any[]): void {
    console.info(message, optionalParams);
  }

  public debug(message: string, ...optionalParams: any[]): void {
    console.debug(message, optionalParams);
  }
}
